import { jsx as _jsx } from "react/jsx-runtime";
import { UnavailablePriceFillIcon } from '@/assets/icons/UnavailablePriceFillIcon';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import ErrorContent from '../ErrorContent';
export const UnavailablePrice = () => {
    const { t } = useShellTranslation();
    return (_jsx(ErrorContent, { title: t('price_block.info_view.price_error_message.title'), description: `${t('price_block.info_view.price_error_message.general_explanation')} ${t('price_block.info_view.price_error_message.advice')}`, image: UnavailablePriceFillIcon }));
};
